import { styled } from '@mui/material/styles';

import { rem, remToGapMultiplier, Theme } from '../../theme';
import { Heading } from '../Heading';
import { Icon } from '../Icon';

export const StyledDialogTitle = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: sticky;
        top: ${theme.tggSpacing(0, 0)};
        z-index: 1;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: ${theme.tggSpacing([rem(2), rem(3), rem(2), rem(3)], [5, 7.5, 5, 7.5])};
        color: ${theme.palette.common.white};
        background-color: ${theme.palette.primary.main};
        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(rem(3), 7.5)};
        }
	`}
`;

type StyledDialogContentProperties = {
    $hasPadding: boolean;
    $isFullHeight: boolean;
    $maxWidth?: number;
    $customPadding?: string;
};

export const StyledDialogContent = styled('div')<StyledDialogContentProperties>`
    ${({
        theme,
        $hasPadding,
        $isFullHeight,
        $customPadding,
        $maxWidth,
    }: StyledDialogContentProperties & { theme: Theme }) => `
        max-width: ${$maxWidth && theme.tggSpacing(rem($maxWidth), $maxWidth * remToGapMultiplier)};
        height: ${$isFullHeight && '100%'};
        padding: ${$hasPadding && theme.tggSpacing([rem(2.2), rem(3)], [9, 7.5])};
        color: ${theme.palette.common.blue};
	`}
`;

export const StyledHeading = styled(Heading)<{
    $maxWidth?: number;
}>`
    ${({ theme }: { theme: Theme }) => theme.typography.text_28_bold_lh_30};
    ${({ theme, $maxWidth }: { theme: Theme; $maxWidth?: number }) => `
        padding-right: ${theme.tggSpacing(rem(2), 5)};
        margin: ${theme.tggSpacing(0, 0)};
        color: ${theme.palette.common.white};
        ${theme.breakpoints.up('desktop')} {
            max-width: ${$maxWidth && `calc(${theme.tggSpacing(rem($maxWidth), $maxWidth * remToGapMultiplier)}rem*0.8)`};
            padding-right: ${theme.tggSpacing(0, 0)};
        }
	`}
`;

export const StyledCloseButton = styled('button')`
    ${({ theme }: { theme: Theme }) => `
        position: absolute;
        right: ${theme.tggSpacing(rem(3), 7.5)};
        display: flex;
        height: fit-content;
        margin: ${theme.tggSpacing(0, 0)};
        cursor: pointer;
        background-color: inherit;
        border: none;
        svg {
            margin: ${theme.tggSpacing('auto', 'auto')};
        }
	`}
`;

export const StyledIcon = styled(Icon)`
    cursor: pointer;
`;
